<!-- DS LeftMenu rail: padding 0 16px 8px (the top inset comes from the list's
     own pt, keeping the space-between column intact). -->
<nav
  class="flex h-full w-full flex-col justify-between bg-page px-4 pt-4 text-ink-1"
>
  <!-- Portal identity zone, level with the grid card's toolbar row: 16px page
       gutter + the 48px toolbar row, hairline at the row's bottom edge (64px
       total, divider full rail width via -mx-4). -->
  <div
    *transloco="let t"
    class="-mx-4 flex h-12 flex-none items-end border-y border-hairline px-4"
  >
    <div
      *transloco="let t"
      class="flex h-12 w-full min-w-0 items-center justify-center"
    >
      @if (inAdminPortal()) {
        <!-- Admin identity: amber capsule + scope line. The tenant switcher is
             meaningless here (no single-org context). -->
        <span
          class="inline-flex shrink-0 items-center gap-1.5 rounded-pill bg-admin-accent py-[5px] pl-2.5 pr-3 font-body text-[12px] font-bold uppercase tracking-wide text-admin-accent-ink"
        >
          <app-icon name="icon-sso" [size]="17" />
          {{ t('topbar.admin') }}
        </span>
        <span class="ml-2.5 min-w-0 truncate text-[11px] font-medium text-ink-2">
          {{ t('topbar.adminScope') }}
        </span>
      } @else {
        <app-tenant-switcher
          class="min-w-0 flex-1"
          [organizations]="organizations()"
          [current]="currentOrganization()"
          [canGoAdmin]="isSuperAdmin()"
          (switchOrganization)="onSwitchOrganization($event)"
          (goAdmin)="onGoAdmin()"
        />
      }
    </div>
  </div>

  <!-- Navigation list -->
  <div class="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto pt-4">
    <div class="flex flex-col">
      @for (item of visibleItems(); track item.route) {
        <!-- DS LeftMenuNavItem: 48px row, padding 8, gap 8, radius 8. Selected
             = downstate overlay-100 (10% black in light) — bg-hairline is
             the token carrying that exact value and it flips for dark. Active
             items don't re-tint on hover — they're already selected. -->
        <a
          [routerLink]="buildRoute(item)"
          class="flex h-12 items-center gap-2 rounded-control p-2 no-underline transition-colors"
          [class]="isActive(item) ? 'bg-hairline' : 'hover:bg-sunken'"
        >
          @if (item.icon) {
            <app-icon
              class="shrink-0"
              [class.text-ink-1]="isActive(item)"
              [class.text-ink-2]="!isActive(item)"
              [name]="isActive(item) ? activeIcon(item) : item.icon"
              [size]="24"
            />
          }
          <span
            class="min-w-0 grow truncate text-button font-semibold"
            [class.text-ink-1]="isActive(item)"
            [class.text-ink-2]="!isActive(item)"
            [class.opacity-80]="!isActive(item)"
          >
            {{ item.label }}
          </span>
        </a>
      }
    </div>
  </div>

  <!-- Bottom: signed-in user card zone, pinned under the scrolling nav list.
       The hairline runs across the full rail width (-mx-4 escapes the px-4). -->
  <div class="-mx-4 mt-4 flex flex-none items-center border-t border-hairline px-4 py-2">
    <app-user-card class="min-w-0 flex-1" />
  </div>
</nav>
